import React from 'react'

import loadable from '@loadable/component'
import { ReactSVG } from 'react-svg'

import {
  DYNAMIC_ASSET_ICON_MENU,
  PERMISSIONS,
  PERMISSIONS_V2,
} from '~/config/constants'

const DevicesPage = loadable(
  () => import('~/pages/Devices') /* webpackChunkName: "Devices" */
)
const Trip = loadable(
  () => import('~/pages/Trip') /* webpackChunkName: "Trip" */
)
const Historical = loadable(
  () => import('~/pages/Historical') /* webpackChunkName: "Historical" */
)

const CyclePage = loadable(
  () => import('~/pages/Cycle') /* webpackChunkName: "CyclePage" */
)

const RouteAssignmentPage = loadable(
  () =>
    import('~/pages/RouteAssignment') /* webpackChunkName: "RouteAssignment" */
)

const Maps = loadable(() => import('~/pages/Map') /* webpackChunkName: "Map" */)

const Tracking = loadable(
  () => import('~/pages/Tracking') /* webpackChunkName: "Tracking" */
)

const Assets = loadable(
  () => import('~/pages/Assets') /* webpackChunkName: "Assets" */
)

const AssetsBus = loadable(
  () => import('~/pages/AssetsBus') /* webpackChunkName: "Assets" */
)

const Groups = loadable(
  () => import('~/pages/Groups') /* webpackChunkName: "Groups" */
)
const Geofence = loadable(
  () => import('~/pages/Geofence') /* webpackChunkName: "Geofence" */
)
const GeofenceAlert = loadable(
  () => import('~/pages/GeofenceAlert') /* webpackChunkName: "GeofenceAlert" */
)
const QualityCheck = loadable(
  () => import('~/pages/QualityCheck') /* webpackChunkName: "QualityCheck" */
)
const ScanIMEIPage = loadable(
  () => import('~/pages/ScanIMEI') /* webpackChunkName: "ScanIMEI" */
)

const ReportBIPage = loadable(
  () => import('~/pages/ReportBI') /* webpackChunkName: "ReportBI" */
)

const ReportBIBusPage = loadable(
  () => import('~/pages/ReportBus') /* webpackChunkName: "ReportBIBus" */
)

const IotCheckAfterSalesPage = loadable(
  () =>
    import(
      '~/pages/IotCheckAfterSales'
    ) /* webpackChunkName: "IotCheckAfterSales" */
)
const PDIPage = loadable(
  () => import('~/pages/PDI') /* webpackChunkName: "PDI" */
)

const IotCheckPDIPage = loadable(
  () => import('~/pages/IotCheckPDI') /* webpackChunkName: "IotCheckPDI" */
)

const Subscriptions = loadable(
  () => import('~/pages/Subscriptions') /* webpackChunkName: "Subscriptions" */
)

const TestHistory = loadable(
  () => import('~/pages/TestHistory') /* webpackChunkName: "TestHistory" */
)

const DriversPage = loadable(
  () => import('~/pages/Drivers') /* webpackChunkName: "TestHistory" */
)

const DriverManagementPage = loadable(
  () =>
    import(
      '~/pages/DriverManagement'
    ) /* webpackChunkName: "DriverManagement" */
)

const CommandHistory = loadable(
  () =>
    import('~/pages/CommandHistory') /* webpackChunkName: "CommandHistory" */
)

const AccessHistory = loadable(
  () => import('~/pages/AccessHistory') /* webpackChunkName: "AccessHistory" */
)

const Dashboard = loadable(
  () => import('~/pages/Dashboard') /* webpackChunkName: "Dashboard" */
)

const Productivity = loadable(
  () => import('~/pages/Productivity') /* webpackChunkName: "Productivity" */
)

const HistoricalBus = loadable(
  () => import('~/pages/HistoricalBus') /* webpackChunkName: "HistoricalBus" */
)

const HistoricalPHR = loadable(
  () =>
    import('~/modules/HistoricalPHR') /* webpackChunkName: "HistoricalPHR" */
)

export default [
  {
    id: 'productivity',
    title: 'Productivity',
    path: '/productivity',
    defaultPath: '/productivity',
    component: Productivity,
    exact: false,
    withHeader: true,
    icon: (
      <ReactSVG
        src="/public/icons/menu-icon/productivity.svg"
        width={24}
        height={24}
      />
    ),
    permission: [
      PERMISSIONS.FMS_READ_PRODUCTIVITY,
      PERMISSIONS_V2.FMS_PRODUCTIVITY,
    ],
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    path: '/dashboard',
    defaultPath: '/dashboard',
    component: Dashboard,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/dashboard.svg" />,
    permission: [PERMISSIONS.FMS_READ_DASHBOARD, PERMISSIONS_V2.FMS_DASHBOARD],
  },
  {
    id: 'historicalPHR',
    title: 'Dasboard PHR',
    path: '/DasboardPHR',
    defaultPath: '/DasboardPHR',
    component: HistoricalPHR,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/dashboard.svg" />,
    permission: [
      PERMISSIONS.FMS_DASHBOARD_PHR,
      PERMISSIONS_V2.FMS_DASHBOARD_PHR,
    ],
  },
  {
    id: 'map',
    title: 'Tracking',
    path: '/map',
    defaultPath: '/map',
    component: Maps,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/map.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_LIVETRACK,
      PERMISSIONS_V2.FMS_TRACKING_ALVA,
    ],
  },
  {
    id: 'tracking',
    title: 'Tracking',
    path: '/tracking',
    defaultPath: '/tracking',
    component: Tracking,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/map.svg" />,
    permission: [
      PERMISSIONS.FMS_TRACKING_PLUS,
      PERMISSIONS_V2.FMS_TRACKING_KALISTA,
    ],
  },
  {
    id: 'playback',
    title: 'Trips',
    path: '/playback/:tab',
    defaultPath: '/playback/trip',
    component: Trip,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/trip.svg" />,
    permission: [PERMISSIONS.FMS_READ_REPORT, PERMISSIONS_V2.FMS_TRIPS],
  },
  {
    id: 'historical',
    title: 'Historical PHR',
    path: '/historical',
    defaultPath: '/historical',
    component: Historical,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/playback.svg" />,
    permission: [
      PERMISSIONS.FMS_PHR_HISTORICAL,
      PERMISSIONS_V2.FMS_HISTORICAL_PHR,
    ],
  },
  {
    id: 'historicalBus',
    title: 'Historical',
    path: '/historicalBus',
    defaultPath: '/historicalBus',
    component: HistoricalBus,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/playback.svg" />,
    permission: [PERMISSIONS.FMS_ASSET_PLUS, PERMISSIONS_V2.FMS_HISTORICAL_BUS],
  },
  {
    id: 'cycle',
    title: 'Cycles',
    path: '/cycle',
    defaultPath: '/cycle',
    component: CyclePage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/cycle.svg" />,
    permission: [PERMISSIONS.FMS_READ_ROUTES, PERMISSIONS_V2.FMS_CYCLE],
  },
  {
    id: 'route-assignment',
    title: 'Penugasan Rute',
    path: '/route-assignment',
    defaultPath: '/route-assignment',
    component: RouteAssignmentPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/route-assignment.svg" />,
    // new menu: v2 permission only, no old permission
    permission: [PERMISSIONS_V2.FMS_ROUTE_ASSIGNMENT],
  },
  {
    id: 'devices',
    title: 'Devices',
    path: '/devices',
    defaultPath: '/devices',
    component: DevicesPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/devices.svg" />,
    permission: [PERMISSIONS.FMS_READ_DEVICE, PERMISSIONS_V2.FMS_DEVICES],
  },
  {
    id: 'drivers',
    title: 'Drivers',
    path: '/drivers',
    defaultPath: '/drivers',
    component: DriversPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/profile.svg" />,
    permission: [PERMISSIONS.FMS_READ_DRIVER, PERMISSIONS_V2.FMS_DRIVERS],
  },
  {
    id: 'driver-management',
    title: 'Driver Management',
    path: '/driver-management',
    defaultPath: '/driver-management',
    component: DriverManagementPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/profile.svg" />,
    permission: [PERMISSIONS.FMS_READ_DRIVER, PERMISSIONS_V2.FMS_DRIVERS],
  },
  {
    id: 'subscriptions',
    title: 'Subscriptions',
    path: '/subscriptions',
    defaultPath: '/subscriptions',
    component: Subscriptions,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/subscriptions.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_SUBSCRIPTIONS,
      PERMISSIONS_V2.FMS_SUBSCRIPTIONS,
    ],
  },
  {
    id: 'assets',
    title: 'Assets',
    path: '/assets',
    defaultPath: '/assets',
    component: Assets,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/assets.svg" />,
    permission: [PERMISSIONS.FMS_READ_ASSET_BIKE, PERMISSIONS_V2.FMS_ASSET],
  },
  {
    id: 'assets-bus',
    title: 'Assets',
    path: '/assets-bus',
    defaultPath: '/assets-bus',
    component: AssetsBus,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/bus.svg" />,
    dynamicIcon: DYNAMIC_ASSET_ICON_MENU,
    permission: [PERMISSIONS.FMS_READ_ASSET_CAR, PERMISSIONS_V2.FMS_ASSET_BUS],
  },
  {
    id: 'pre-delivery',
    title: 'Pre Delivery Inspection',
    path: '/pre-delivery',
    defaultPath: '/pre-delivery',
    component: PDIPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/assets.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_PREDELIVERY_ASSETS,
      PERMISSIONS_V2.FMS_PRE_DELIVERY,
    ],
  },
  {
    id: 'pre-delivery-iot',
    title: 'Iot Check',
    path: '/pre-delivery-iot',
    defaultPath: '/pre-delivery-iot',
    component: IotCheckPDIPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/iotcheck.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_PREDELIVERY_ASSETS,
      PERMISSIONS_V2.FMS_IOT_CHECK_PDI,
    ],
  },
  {
    id: 'groups',
    title: 'Groups',
    path: '/groups',
    defaultPath: '/groups',
    component: Groups,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/groups.svg" />,
    permission: [PERMISSIONS_V2.FMS_GROUPS],
  },
  {
    id: 'geofence',
    title: 'Geofencing',
    path: '/geofence',
    defaultPath: '/geofence',
    component: Geofence,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/geofencing.svg" />,
    permission: [PERMISSIONS.FMS_READ_GEOFENCE, PERMISSIONS_V2.FMS_GEOFENCE],
  },
  {
    id: 'alerts',
    title: 'Alerts',
    path: '/alerts',
    defaultPath: '/alerts',
    component: GeofenceAlert,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/geo-alert.svg" />,
    permission: [PERMISSIONS.FMS_READ_ALERT, PERMISSIONS_V2.FMS_GEOFENCE_ALERT],
  },
  {
    id: 'qualitycheck',
    title: 'Quality Check',
    path: '/qualitycheck',
    defaultPath: '/qualitycheck',
    component: QualityCheck,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/qc-icon.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_MANUFACTURE,
      PERMISSIONS_V2.FMS_QUALITY_CHECK,
    ],
  },
  {
    id: 'scan-imei',
    title: 'IoT Check',
    path: '/scan-imei',
    defaultPath: '/scan-imei',
    component: ScanIMEIPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/iotcheck.svg" />,
    permission: [PERMISSIONS.FMS_READ_IOT, PERMISSIONS_V2.FMS_IOT_CHECK],
  },
  {
    id: 'iot-check-after',
    title: 'IoT Check After Sales',
    path: '/iot-check-after',
    defaultPath: '/iot-check-after',
    component: IotCheckAfterSalesPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/iotcheck.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_IOT_CHECK_AFTER_SALES,
      PERMISSIONS_V2.FMS_IOT_CHECK_AFTER_SALES,
    ],
  },
  {
    id: 'access-history',
    title: 'Access History',
    path: '/access-history',
    defaultPath: '/access-history',
    component: AccessHistory,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/access.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_COMMAND_ACCESS_HISTORY,
      PERMISSIONS_V2.FMS_ACCESS_HISTORY,
    ],
  },
  {
    id: 'command-history',
    title: 'Command History',
    path: '/command-history',
    defaultPath: '/command-history',
    component: CommandHistory,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/command.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_TEST_RECORD,
      PERMISSIONS_V2.FMS_COMMAND_HISTORY,
    ],
  },
  {
    id: 'test-history',
    title: 'Test History',
    path: '/test-history',
    defaultPath: '/test-history',
    component: TestHistory,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/test-history.svg" />,
    permission: [
      PERMISSIONS.FMS_READ_TEST_RECORD,
      PERMISSIONS_V2.FMS_TEST_HISTORY,
    ],
  },
  {
    id: 'report',
    title: 'Report Alva',
    path: '/report',
    defaultPath: '/report',
    component: ReportBIPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/dashboard.svg" />,
    permission: [PERMISSIONS.FMS_READ_REPORT_GROUP, PERMISSIONS_V2.FMS_REPORT],
  },
  {
    id: 'report-bus',
    title: 'Report Kalista',
    path: '/report-bus',
    defaultPath: '/report-bus',
    component: ReportBIBusPage,
    exact: false,
    withHeader: true,
    icon: <ReactSVG src="/public/icons/menu-icon/dashboard.svg" />,
    permission: [PERMISSIONS.FMS_REPORT_KALISTA, PERMISSIONS_V2.FMS_REPORT_BUS],
  },
]
